import { STEPS } from "../../Containers/LayoutOnboarding/utils/constants/steps"
import { choiceIncludes, FEATURES } from "./productChoice"

export const FEATURES_STEP_KEY = "FEATURES"

// Steps that only exist for Prevent: without alerts there is nothing to enroll in or activate
// (OB-X-01). Everything else is shared by both products.
const PREVENT_ONLY_STEP_KEYS = ["ENROLLMENT", "ALERTS"]

export const getSkippedStepKeys = (choice) =>
  choiceIncludes(choice, FEATURES.PREVENT) ? [] : PREVENT_ONLY_STEP_KEYS

// The rows of the flow that apply, in order. `excludeKeys` carries whatever the caller already
// knows does not apply — the billing steps a user account no longer needs (OB-X-02) — so every
// surface (checklist, rail, dots, redirects) filters from the same list.
export const getApplicableSteps = ({ choice, excludeKeys = [] }) => {
  const skipped = [...getSkippedStepKeys(choice), ...excludeKeys]

  return STEPS.filter((s) => !skipped.includes(s.step))
}

// The first applicable backend step at or after `stepId` — the step the merchant actually
// lands on when the one the backend points at was skipped by their choice.
export const nextApplicableStepId = ({ stepId, steps, stepMap }) => {
  const ids = steps.map((s) => stepMap[s.step]).filter((id) => id !== undefined)

  return ids.find((id) => id >= stepId) ?? ids[ids.length - 1] ?? stepId
}

export const previousApplicableStepId = ({ stepId, steps, stepMap }) => {
  const ids = steps.map((s) => stepMap[s.step]).filter((id) => id !== undefined)

  return ids.filter((id) => id < stepId).pop() ?? stepId
}
